import { Alert, Button, Stack, TextField, Typography } from "@mui/material"
import { useContext, useState } from "react"
import { Link, useParams } from "react-router-dom"

import AuthContext 		from "../../context/AuthProvider"
import GeneralError 	from "../../components/GeneralError"
import useFetch 		from "../../api/api"
import config from "../../common/Config"

const ChangePassword = () => {

	const {token}									= useParams()
	const {auth}									= useContext(AuthContext)

	const [returnObject, setReturnObject]			= useState()
	const [formState, setFormState]					= useState(formFields)

	const privateFetch								= useFetch()
	const fetch										= auth ? privateFetch : fetch

	const handleSubmit = (e) => {
		e.preventDefault()

		// Percorre todos os campos e verifica se está valido ou não
		Object.keys(formFields).map(k => {
			if (e.target[k]) {
				formFields[k].error = !e.target[k].validity.valid
				setFormState(prevState => ({
					...prevState,
					[k] : {
						...prevState[k],
						error : !e.target[k].validity.valid
					}
				}))
			}
		})
		
		if (e.target.checkValidity()) {
			fetch(config.apiUrl +'/changePassword/'+ (token ? token : ''), {
				method : 'POST',
				headers : {
					'content-type' : 'application/json; charset=utf-8',
				},
				body : JSON.stringify({
					oldPassword	: formState.oldPassword.value,	
					password 	: formState.password.value
				})
			})
			.then(result => result.json())
			.then(result => {
				setFormState(formFields)
				switch (result.status) {
					case 200 : {
						setReturnObject({
							status		: "success",
							message		: <Typography>Senha alterada com successo. Clique <Link to="/login">aqui</Link> para efetuar login.</Typography>
						})
						break;
					}
					case 401 : {
						setReturnObject({
							status		: "error",
							message		: <Typography>Token inválido. Clique <Link to="/recoverPassword">aqui</Link> para solicitar novamente.</Typography>
						})
						break;
					}
					case 403 : {
						setReturnObject({
							status		: "error",
							message		: <Typography>Senha atual inválida.</Typography>
						})
						break;
					}					
					default : {
						setReturnObject({
							status		: "error",
							message		: <Typography>Ocorreu um erro ao trocar a senha. Clique <Link to="/recoverPassword">aqui</Link> para tentar novamente.</Typography>
						})
						break;
					}
				}
			})
		}
	}

	const handleFormChange = (e) => {
		setFormState(prevState => ({
			...prevState, 
			[e.target.name] : {
				value : e.target.value
			}
		}))
	}

	// Verifica se está tentando trocar a senha sem estar logado ou sem 
	if (!token && !auth.userId) {
		return (
			<GeneralError message={<Typography>Você precisa estar logado para efetuar essa operação. Clique <Link to="/login">aqui</Link> para efetuar o login.</Typography>}/>
		)
	}
	
	return (

			// <Box display={'flex'} width={'50%'} height={'100%'} alignItems={'center'}>
				<Stack component={'form'} direction={'column'} width={'100%'} spacing={2} onSubmit={handleSubmit} noValidate>
					<Typography variant="h5">Altere sua senha</Typography>
					{ returnObject ? <Alert severity={returnObject.status}>{returnObject.message}</Alert> : null}
					{ !token ? (
						<TextField 
							type={"password"} 
							name="oldPassword"
							label="Digite a sua senha atual" 
							value={formState.oldPassword.value} 
							onChange={handleFormChange}
							error={formState.oldPassword.error}
							helperText={formState.oldPassword.error && "Você deve digitar a senha atual."}
							required 
							fullWidth
						/>
					): null}

					<TextField 
						type={"password"} 
						name="password"
						label="Digite a sua nova senha" 
						value={formState.password.value} 
						onChange={handleFormChange}
						error={formState.password.error}
						helperText={formState.password.error && "Você deve digitar uma senha."}
						required 
						fullWidth
					/>
					<TextField 
						type={"password"} 
						name="retypedPassword"
						label="Repita a sua nova senha" 
						value={formState.retypedPassword.value} 
						onChange={handleFormChange}
						error={formState.retypedPassword.error}
						helperText={formState.retypedPassword.error && "As senhas devem ser idênticas"}
						inputProps={{pattern : formState.password.value}}
						required 
						fullWidth
					/>					
					<Button type="submit" variant="contained" sx={{width: 200}}>Alterar Senha</Button>
				</Stack>
			// </Box>
	)
}

const formFields = {
	oldPassword : {
		error 	: false,
		value	: ''
	},
	password : {
		error 	: false,
		value	: ''
	},
	retypedPassword : {
		error	: false,
		value	: ''
	}
}

export default ChangePassword